import { createSlice } from '@reduxjs/toolkit'

export const campaignSlice = createSlice({
    name: 'campaigns',
    initialState: {
        campaigns: [],
        ruleTypes: [],
    },
    reducers: {
        loadCampaigns: (state, action) => {
            state.campaigns = action.payload
        },
        loadRuleTypes: (state, action) => {
            state.ruleTypes = action.payload
        }
    }
})
export default campaignSlice.reducer

export const { loadCampaigns, loadRuleTypes } = campaignSlice.actions

export const getAllCampaigns = (state) => state.campaigns.campaigns || [];
export const getAllRuleTypes = (state) => state.campaigns.ruleTypes || [];
